import { Card } from "@models/Card";
import { Rank } from "@models/Rank";

const rankTypeMap: {
  twopair: string;
  pair: string;
  highcard: string;
  straight: string;
  flush: string;
  fullhouse: string;
  threekind: string;
  fourofakind: string;
  fourkind: string;
  straightflush: string;
  royalflush: string;
} = {
  twopair: "Two Pair",
  pair: "Pair",
  highcard: "High Card",
  straight: "Straight",
  flush: "Flush",
  fullhouse: "Full House",
  threekind: "Three of a Kind",
  fourofakind: "Four of a Kind",
  fourkind: "Four of a Kind",
  straightflush: "Straight Flush",
  royalflush: "Royal Flush",
};

type RankTypeKeys = keyof typeof rankTypeMap;

export default function useHandRank(): {
  translateRankType: (value: RankTypeKeys) => string;
  getCards: (rank: Rank, hasExtraCard: boolean) => Card[];
  } {
  const translateRankType = (value: RankTypeKeys) => {
    if (!value) return "";
    return rankTypeMap[value] ?? value;
  };

  const getCards = (rank: Rank, hasExtraCard: boolean) => {
    const allCards = [...rank.rankCards, ...rank.kickerCards, ...rank.extraCards];
  
    if (!hasExtraCard && allCards.length > 5) {
      allCards.splice(5, 1);
    }
    return allCards;
  };

  return { translateRankType, getCards };
}
